<template>
  <div>
    <b-dropdown class="w-100" text="Adjon hozzá egy feltételt...">
      <b-dropdown-item
        v-for="(item, itemIndex) in items"
        :key="`${item._id}-item-${itemIndex}`"
        @click="onItemClicked(item)"
        >{{ item.name }}</b-dropdown-item
      >
    </b-dropdown>
    <div
      v-for="(item, itemIndex) in selectedItems"
      :key="`${item._id}-item-${itemIndex}`"
      class="complex-filter-container"
    >
      <b-row>
        <b-col md="8">
          {{ item.name }}
        </b-col>
        <b-col md="4" @click="onItemRemoved(item)" class="delete-complex-filter"> Törlés </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  props: ['items', 'selectedItems', 'onChanged'],
  methods: {
    onItemClicked: function(item) {
      const newItems = _.uniq([...this.selectedItems, item])
      this.onChanged(newItems)
    },
    onItemRemoved: function(itemIndex) {
      const newItems = [...this.selectedItems]
      newItems.splice(itemIndex, 1)
      this.onChanged(newItems)
    }
  }
}
</script>
<style scoped>
.delete-complex-filter {
  color: red;
}

.delete-complex-filter:hover {
  cursor: pointer;
  color: sienna;
}

.complex-filter-container {
  margin-top: 10px;
}
</style>
